import * as React from "react";
import { AssetClassHeader } from "../AssetClassHeader/AssetClassHeader";
import { FundNameRow } from "../FundNameRow/FundNameRow";
import { SectorBenchmarkRow } from "../SectorBenchmarkRow/SectorBenchmarkRow";

interface IAssetClassGroupState {
    fundNames?: any;
}

interface LProps {
    key?: string;
    fundNames?: any;
    isins?: any;
    translations?: string[];
    sectorTranslations?: string[];
}

export class AssetClassGroup extends React.Component<LProps, IAssetClassGroupState>{

    constructor(props) {
        super(props);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ fundNames: nextProps });
    }

    render() {
        let assetClass = this.getAssetClassTranslation(this.props.translations, this.props.fundNames);
        let fundRows = this.buildFundRows(this.props.fundNames, this.props.isins, this.props.translations, this.props.sectorTranslations);

        return (
            <tbody>
                <AssetClassHeader key={"" + 0} title={assetClass || this.props.fundNames[0].assetClass} />
                {fundRows}
            </tbody>
        );
    }

    buildFundRows(funds, idents, translationObj, sectorTranslations) {
        // Add fundname rows and benchmark and sector rows if data exists
        let fundRows = [];
        for (let i = 0; i < funds.length; i++) {

            fundRows.push(
                <FundNameRow
                    key={funds[i]['ticker']}
                    name={funds[i]['name']}
                    isin={idents[i]['isin']}
                    perfData={funds[i].stats}
                    url={funds[i].url}
                    translation={translationObj}
                />);

            if (funds[i]["benchMarkData"]["peer_group_sec_id"] !== "0" && funds[i]["benchMarkData"]["sector_stats"]) {
                fundRows.push(
                    <SectorBenchmarkRow
                        key={"sector" + i} isIndex
                        name={funds[i]["benchMarkData"]["peer_group"]}
                        isin={idents[i]['isin']}
                        stats={funds[i]["benchMarkData"]["sector_stats"]}
                        translations={sectorTranslations}
                    />
                );
            }
        }
        return fundRows;
    }

    getAssetClassTranslation(tran, funds) {
        for (let p in tran) {
            if (tran[p][2] === funds[0]["assetClass"]) {
                return tran[p][3];
            }
        }
        return funds[0]["assetClass"];
    }
}



// WEBPACK FOOTER //
// ./src/client/Rankia/Components/AssetClassGroup/AssetClassGroup.tsx